import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import colors from "../styles/colors";
import { Card, CardHeaderNumber, CardContentLine } from "./MetricsCard";
import { getFilteredContacts } from "../util/customersUtil";

import {
	DashboardFilteresTypes,
	DashboardFiltersSubTypes,
} from "../util/CustomerFilterEnum";
import useMutateAnalytics from "../util/mutate.Analytics";
import analyticsKeys from "../util/UsageStatLinks";

export default function CouponRedemptionCard({ metrics, timeRange }) {
	const { setApp } = useContext(AppContext);
	const isNewClickable = metrics?.couponsRedeemedNew > 0;
	const isReturningClickable = metrics?.couponsRedeemedRepeat > 0;
	const isReferrersClickable = metrics?.couponsRedeemedAffiliate > 0;
	const history = useHistory();
	const mutateAnalytics = useMutateAnalytics()

	const onClickHandler = (subType) =>
		getFilteredContacts(setApp, history, {
			type: DashboardFilteresTypes.DiscountRedemptions,
			subType,
			...timeRange,
		});

	return (
		<Card title="Discount Redemptions">
			<CardHeaderNumber>
				{metrics?.couponsRedeemedTotal.toString()}
			</CardHeaderNumber>
			<CardContentLine
				left="New Customers"
				right={metrics?.couponsRedeemedNew.toString()}
				color={isNewClickable ? colors.seaGreen : colors.grey2}
				onClick={
					isNewClickable
						? () => {
								const mutateAnalyticsVariables = {
									link: analyticsKeys.DASHBOARD_DISCOUNT_REDEMPTION_NEW_CUSTOMER,
								};
								mutateAnalytics(mutateAnalyticsVariables);
								onClickHandler(DashboardFiltersSubTypes.New);
						  }
						: null
				}
			/>

			<CardContentLine
				left="Returning Customers"
				right={metrics?.couponsRedeemedRepeat.toString()}
				color={isReturningClickable ? colors.seaGreen : colors.grey2}
				onClick={
					isReturningClickable
						? () => {
								const mutateAnalyticsVariables = {
									link: analyticsKeys.DASHBOARD_DISCOUNT_REDEMPTION_RETURNING_CUSTOMER,
								};
								mutateAnalytics(mutateAnalyticsVariables);
								onClickHandler(DashboardFiltersSubTypes.Returning);
						  }
						: null
				}
			/>

			<CardContentLine
				left="Referrers"
				right={metrics?.couponsRedeemedAffiliate.toString()}
				color={isReferrersClickable ? colors.seaGreen : colors.grey2}
				onClick={
					isReferrersClickable
						? () => {
								const mutateAnalyticsVariables = {
									link: analyticsKeys.DASHBOARD_DISCOUNT_REDEMPTION_REFERRERS_CUSTOMER,
								};
								mutateAnalytics(mutateAnalyticsVariables);
								onClickHandler(DashboardFiltersSubTypes.Referrers);
						  }
						: null
				}
			/>
		</Card>
	);
}
